<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <LoadingComponent :loading="loading" :message="loadingMessage" :progress-percent="loadingProgressPercent"
            style="z-index: 1000;"></LoadingComponent>

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="unidades" v-model="unidadeSelecionada" item-text="descricao_unidade"
                            item-value="id_unidade" :label="$t('nav.registration.units')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <LazySelect get-url="getGruposlazy" text="nome" value="id_grupo"
                            :label="$t('nav.registration.groups')" @input="grupoSelecionado = $event" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
                            :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
                            :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable :headers="headers" :items="usuarios" :loading="loadingtable"
            :default-multi-sort="defaultSort" :server-items-length="totalUsuarios" :items-per-page="numberOfRows"
            :items-per-page-last-option="itemsPerPageLastOption"
            :server-sort-by="serverSortBy" :server-sort-desc="serverSortDesc" :last-item="250"
            cod-tabela="USUARIOSPASSAGEIROS"
            @update:headers="headers = $event"
            @update:options="onTableOptions" @update:filters="onFiltersUpdate"
            :loading-text="$t('passengersUsers.loading')">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('passengersUsers.title')" :token="token"
                    :items="usuarios"
                    :load-items-for-export="loadItemsForExport"
                    background-export
                    list-endpoint="getusuariospessoas"
                    :export-filters="exportFiltersForCsv"
                    :export-sort-by="serverSortBy"
                    :export-sort-desc="serverSortDesc"
                    :export-total="totalUsuarios"
                    id-field="id_usuario"
                    csv-title="usuariospassageiros" :pdf-title="$t('passengersUsers.title')" :pdf-headers="headers"
                    pdf-filename="usuariospassageiros" hide-search
                    @export-loading="onExportLoading">
                    <template v-slot:extension>
                        <v-tooltip top>
                            <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
                                <v-dialog v-model="dialogFindInDatabase" max-width="80%">
                                <template v-slot:activator="{ on: onDialog, attrs: attrsDialog }">
                                    <v-btn color="#4a4a4a" dark small class="mb-2 mr-2" v-bind="{ ...attrsTooltip, ...attrsDialog }" v-on="{ ...onTooltip, ...onDialog }" fab>
                                    <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-toolbar dark color="primary">
                                    <v-btn icon dark @click="closeDialogFindInDatabase">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ $t('passengers.findInDatabase') }}</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                    <v-form ref="formFindInDatabase" v-model="formFindInDatabaseValidado">
                                        <v-row>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-text-field v-model="docToSearch" :label="$t('passengers.personal.cpf')"
                                            :rules="[findInDatabaseDocRules]" @input="onFindInDatabaseFieldChange"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-text-field v-model="emailToSearch" :label="$t('passengers.personal.email')"
                                            :rules="[findInDatabaseEmailRules]" @input="onFindInDatabaseFieldChange"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-text-field v-model="regToSearch" :label="$t('passengers.personal.registrationCode')"
                                            :rules="[findInDatabaseRegRules]" @input="onFindInDatabaseFieldChange"></v-text-field>
                                        </v-col>
                                        </v-row>
                                    </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" @click="searchInDatabase">{{ $t('button.search') }}</v-btn>
                                    </v-card-actions>
                                </v-card>
                                </v-dialog>
                            </template>
                            <span>{{ $t('passengers.findInDatabase') }}</span>
                            </v-tooltip>
                    </template>
                </CadastroToolbar>
            </template>
        </MerusDataTable>
    </v-container>

</template>
<script>

import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MerusDataTable from "../components/Tables/MerusDataTable.vue"
import DateUtils from '@/utils/dateutils';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import LoadingComponent from './LoadingComponent.vue';
import LazySelect from './Selects/LazySelect.vue';
import serverTableMixin from "@/mixins/serverTableMixin";
import { buildRequestParams, computePageState, initSortFromDefault, samePageAndSort } from "@/utils/serverTablePagination";

/** Tamanho de página nas requisições de exportação para reduzir timeout e memória por resposta. */
const EXPORT_FETCH_PAGE_SIZE = 100;

export default {
    mixins: [serverTableMixin],
    components: {
        MerusDataTable,
        CadastroToolbar,
        LoadingComponent,
        LazySelect
    },
    data: () => ({
        user: null,
        token: null,
        formValidado: false,
        unidades: [],
        unidadeSelecionada: null,
        grupoSelecionado: null,
        search: "",
        usuarios: [],
        loadingtable: false,
        headers: [],
        totalUsuarios: 0,
        numberOfRows: 10,
        /** Limite da última opção do rodapé (alinhar com computePageState). */
        itemsPerPageLastOption: 250,
        lastItemsPerPageBeforeTodos: null,
        pageNumber: 1,
        serverSortBy: [],
        serverSortDesc: [],
        searchFilters: {},
        baseFilters: {},
        columnFilters: {},
        hasLoadedReport: false,
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        config: null,
        loadingMessageInternal: null,
        loadingExport: false,
        loadingProgressPercent: null,
        dialogFindInDatabase: false,
        formFindInDatabaseValidado: false,
        docToSearch: null,
        emailToSearch: null,
        regToSearch: null,
    }),
    computed: {
        loadingMessage: {
            get() {
                return this.loadingMessageInternal || this.$t('system.messages.loading');
            },
            set(value) {
                this.loadingMessageInternal = value;
            }
        },
        exportFiltersForCsv() {
            return this.getMergedFilters();
        },
        loading() {
            return this.loadingtable || this.loadingExport;
        },
        defaultSort() {
            return [
                { value: 'nome_completo', options: { text: this.$t('routs.increasing'), value: 1 } }];
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar"
            }
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
                rules: [this.dtRules]
            }
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
                rules: [this.dtRules]
            }
        },
        dtRules() {
            return [() => true];
        }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {

        onExportLoading(payload) {
            if (!payload || typeof payload !== 'object') return;
            this.loadingExport = !!payload.loading;
            if (payload.loading) {
                if (payload.message) {
                    this.loadingMessage = payload.message;
                }
                if (Object.prototype.hasOwnProperty.call(payload, 'progress')) {
                    const p = Number(payload.progress);
                    this.loadingProgressPercent = Number.isFinite(p)
                        ? Math.min(100, Math.max(0, Math.round(p)))
                        : null;
                }
            }
            if (!payload.loading) {
                this.loadingProgressPercent = null;
                if (this.loadingtable) {
                    this.loadingMessage = this.$t('passengersUsers.loading');
                } else {
                    this.loadingMessageInternal = null;
                }
            }
        },
        initialize() {
            if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
                const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
                this.serverSortBy = serverSortBy;
                this.serverSortDesc = serverSortDesc;
            }
            this.getConfig();
            this.populaUnidades();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                },
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [
                        { id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' },
                        ...(response.data || []),
                    ];
                },
            });
        },
        populaRelatorio() {
            this.$refs.form.validate();
            if (!this.formValidado) {
                return;
            }
            this.baseFilters = {
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf),
                id_unidade: this.unidadeSelecionada == null || this.unidadeSelecionada === ''
                    ? null
                    : Number(this.unidadeSelecionada),
                id_grupo: this.grupoSelecionado
            };
            this.pageNumber = 1;
            this.hasLoadedReport = true;
            this.serverTableLoad();
        },
        onTableOptions(opts) {
            if (!this.hasLoadedReport || this.loadingtable) return;
            if (!opts) {
                this.serverTableLoad(opts);
                return;
            }
            const state = {
                pageNumber: this.pageNumber,
                numberOfRows: this.numberOfRows,
                serverSortBy: this.serverSortBy,
                serverSortDesc: this.serverSortDesc,
            };
            if (samePageAndSort(opts, state) && !this.loadingtable) {
                return;
            }
            this.serverTableLoad(opts);
        },
        onFiltersUpdate(filters) {
            if (!this.hasLoadedReport) return;
            const next = filters || {};
            if (JSON.stringify(next) === JSON.stringify(this.columnFilters)) return;
            this.columnFilters = next;
            this.pageNumber = 1;
            this.serverTableLoad();
        },
        getMergedFilters() {
            return {
                ...this.baseFilters,
                ...this.columnFilters
            };
        },
        serverTableLoad(options) {
            const mergedFilters = this.getMergedFilters();
            this.searchFilters = mergedFilters;
            const state = {
                pageNumber: this.pageNumber,
                numberOfRows: this.numberOfRows,
                serverSortBy: this.serverSortBy,
                serverSortDesc: this.serverSortDesc,
                searchFilters: mergedFilters,
                lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
                total: this.totalUsuarios,
            };
            const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
            this.loadingtable = true;
            this.loadingMessage = this.$t('passengersUsers.loading');
            apiController.request(apiController.endpoints.getUsuariospessoas, {
                data: params,
                onSuccess: (response) => {
                    const data = response.data;
                    if (data && typeof data.total === 'number' && Array.isArray(data.items)) {
                        this.usuarios = data.items;
                        const updates = computePageState(data, { page, rowsPerPage, sortByArr, sortDescArr }, state, this.itemsPerPageLastOption);
                        this.totalUsuarios = updates.total;
                        this.pageNumber = updates.pageNumber;
                        this.numberOfRows = updates.numberOfRows;
                        this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
                        this.serverSortBy = updates.serverSortBy;
                        this.serverSortDesc = updates.serverSortDesc;
                    } else {
                        this.usuarios = Array.isArray(data) ? data : [];
                        this.totalUsuarios = this.usuarios.length;
                    }
                    this.loadingtable = false;
                    this.loadingMessageInternal = null;
                },
                onError: () => {
                    this.loadingtable = false;
                    this.loadingMessageInternal = null;
                },
            });
        },
        /**
         * Busca todos os registros para exportação em várias páginas (menos risco de timeout)
         * e com yields entre requisições para não bloquear a UI.
         */
        async loadItemsForExport(onProgress) {
            if (!this.hasLoadedReport) {
                return [];
            }
            const chunk = EXPORT_FETCH_PAGE_SIZE;
            const mergedFilters = this.getMergedFilters();
            const all = [];
            let page = 1;
            let total = null;

            const yieldToUi = () => new Promise((r) => setTimeout(r, 0));
            const report = typeof onProgress === 'function' ? onProgress : null;
            if (report) report(0);

            while (page < 10000) {
                const state = {
                    pageNumber: page,
                    numberOfRows: chunk,
                    serverSortBy: this.serverSortBy,
                    serverSortDesc: this.serverSortDesc,
                    searchFilters: mergedFilters,
                    lastItemsPerPageBeforeTodos: null,
                    total: total != null ? total : this.totalUsuarios,
                };
                const { params } = buildRequestParams(
                    {
                        page,
                        itemsPerPage: chunk,
                        sortBy: this.serverSortBy,
                        sortDesc: this.serverSortDesc,
                    },
                    state
                );

                let response;
                try {
                    response = await apiController.request(apiController.endpoints.getUsuariospessoas, {
                        data: params,
                        silent: true,
                    });
                } catch (e) {
                    return all.length ? all : [];
                }

                const data = response.data;
                let items = [];

                if (data && typeof data.total === 'number' && Array.isArray(data.items)) {
                    total = data.total;
                    items = data.items;
                } else if (Array.isArray(data)) {
                    items = data;
                    total = items.length;
                } else {
                    break;
                }
                all.push(...items);
                if (report && total != null && total > 0) {
                    const pct = Math.min(100, Math.round((all.length / total) * 100));
                    report(pct);
                }
                await yieldToUi();

                if (items.length === 0) {
                    break;
                }
                if (total != null && all.length >= total) {
                    break;
                }
                if (!data.total && Array.isArray(data)) {
                    break;
                }
                page += 1;
            }

            if (report) report(100);
            return all;
        },
        onHeadersChanged(updatedHeaders) {
            if (updatedHeaders) {
                this.headers = updatedHeaders;
            }
        },
        searchInDatabase() {
            if (!this.$refs.formFindInDatabase || !this.$refs.formFindInDatabase.validate()) {
                return;
            }
            this.loadingMessage = this.$t('passengers.messages.processing');
            this.loadingFindInDatabase = true;

            if (this.docToSearch || this.emailToSearch || this.regToSearch) {
                apiController.request(apiController.endpoints.getPessoaporchavesunicas, {
                    data: {
                        doc: this.docToSearch || this.emailToSearch || this.regToSearch,
                    },
                    silent: true,
                    onSuccess: (response) => {
                        if (response.data?.length > 0) {
                            this.usuarios = response.data;
                            this.totalUsuarios = response.data.length;
                            this.pageNumber = 1;
                            this.closeDialogFindInDatabase();
                        } else {
                            EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('passengers.messages.noDataFound') });
                        }
                        this.loadingFindInDatabase = false;
                    },
                    onError: (error) => {
                        console.log("error", error);
                        EventBus.$emit('show-error', { error });
                        this.loadingFindInDatabase = false;
                    },
                });
            }
        },
        closeDialogFindInDatabase() {
            this.dialogFindInDatabase = false;
            this.docToSearch = null;
            this.emailToSearch = null;
            this.regToSearch = null;
            this.formFindInDatabaseValidado = false;
            if (this.$refs.formFindInDatabase) {
                this.$refs.formFindInDatabase.resetValidation();
            }
        },
        onFindInDatabaseFieldChange() {
            this.$nextTick(() => {
                this.$refs.formFindInDatabase?.validate();
            });
        },
        findInDatabaseDocRules() {
            return true;
        },
        findInDatabaseEmailRules() {
            return true;
        },
        findInDatabaseRegRules() {
            return true;
        },
    }
}
</script>
<style lang="">

</style>
